export default __webpack_public_path__ + "static/media/R_wdt_c_cap_1.6cc4c557.mp3";